const SCROLL_SPEED = 38;
const DESKTOP_MQ = '(min-width: 750px)';

/**
 * @param {HTMLElement} root
 */
function setupArtistCarousel(root) {
  const track = root.querySelector('[data-carousel-track]');
  const seed = root.querySelector('[data-carousel-seed]');

  if (!(track instanceof HTMLElement) || !(seed instanceof HTMLElement)) {
    return;
  }

  const desktop = window.matchMedia(DESKTOP_MQ);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastShift = 0;
  let lastMode = '';

  const clearClones = () => {
    track.querySelectorAll('[data-carousel-clone]').forEach((node) => node.remove());
    track.style.removeProperty('--marquee-shift');
    track.style.removeProperty('animation-duration');
    root.removeAttribute('data-carousel-auto');
  };

  /**
   * @param {HTMLElement} source
   */
  const appendClone = (source) => {
    const clone = source.cloneNode(true);
    if (!(clone instanceof HTMLElement)) return null;

    clone.removeAttribute('data-carousel-seed');
    clone.setAttribute('data-carousel-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('a').forEach((link) => {
      link.setAttribute('tabindex', '-1');
    });
    track.appendChild(clone);
    return clone;
  };

  const enableMarquee = () => {
    const wantsAuto = desktop.matches && !reducedMotion.matches && seed.children.length >= 2;

    if (!wantsAuto) {
      clearClones();
      lastShift = 0;
      lastMode = 'manual';
      return;
    }

    // Measure seed before cloning so shift distance stays correct.
    const seedWidth = seed.getBoundingClientRect().width;
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const shift = seedWidth + gap;

    if (!shift) {
      clearClones();
      lastMode = 'manual';
      return;
    }

    // Skip rebuild if geometry did not change meaningfully.
    if (lastMode === 'auto' && Math.abs(shift - lastShift) < 1) {
      return;
    }

    clearClones();

    let totalWidth = seedWidth;
    let copies = 1;

    while (totalWidth + gap < window.innerWidth * 2 && copies < 6) {
      appendClone(seed);
      totalWidth += seedWidth + gap;
      copies += 1;
    }

    if (copies < 2) {
      appendClone(seed);
    }

    const duration = shift / SCROLL_SPEED;
    track.style.setProperty('--marquee-shift', `${shift}px`);
    track.style.animationDuration = `${duration}s`;
    root.setAttribute('data-carousel-auto', '');
    lastShift = shift;
    lastMode = 'auto';
  };

  const update = () => {
    requestAnimationFrame(enableMarquee);
  };

  update();

  desktop.addEventListener('change', update);
  reducedMotion.addEventListener('change', update);
  window.addEventListener('resize', update, { passive: true });
}

document.querySelectorAll('[data-malle-artist-carousel]').forEach((root) => {
  if (root instanceof HTMLElement) setupArtistCarousel(root);
});
